import { BaseRepository } from "repositories/BaseRepository";

export class QuicklyRepliesRepository extends BaseRepository {
  constructor(db) {
    super(db, "quicklyReplies");
  }
}
